module.exports = __webpack_public_path__ + "static/media/salah.5645d7d0.png";